import script from "./goRinSyo0035.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0035.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0035.vue?vue&type=style&index=0&id=aed4b04c&lang=scss"

const __exports__ = script;

export default __exports__